import * as yup from 'yup'
import { REQUIRED_FIELD } from 'constants/errors'
import { DealResolvableCategories, StatusPayment } from 'typescript/enums/transactions'
import { REJECTION_CODE_CATEGORY, REJECTION_CODE_DIRECTION } from 'constants/rejectionCodes'

export const schemaDealPayment = yup.object().shape({
  scheduledFor: yup.string().nullable().required(REQUIRED_FIELD),
  // amount: yup.string().required(REQUIRED_FIELD).matches(integerWithNegativeReg, ONLY_DIGITS),
  // achProvider: yup.string().required(REQUIRED_FIELD),
  bankAccountId: yup.string().required(REQUIRED_FIELD),
  status: yup.string().required(REQUIRED_FIELD),
  category: yup.string().required(REQUIRED_FIELD).test('resolvable-category', 'Category is not eligible for resolution', function (value) {
    const { resolvePayment } = this.parent
    return !resolvePayment || DealResolvableCategories.includes(value ?? '')
  }),
  paymentDate: yup.string().nullable(),
  comments: yup.string().when(['status', 'category'], {
    is: (status, category) => status === StatusPayment.rejected && category !== 'Payment ACH',
    then: yup.string().required(REQUIRED_FIELD),
    otherwise: yup.string().nullable(),
  }),
  vendorId: yup.string().test('is-req', REQUIRED_FIELD, function (value) {
    const { category } = this.parent
    return category !== 'LegalCostVendor' || !!value
  }),
  rejectionCode: yup.string().test('is-req', REQUIRED_FIELD, function (value) {
    const { status, category, direction } = this.parent
    const applicable =
      status === StatusPayment.rejected && category === REJECTION_CODE_CATEGORY && direction === REJECTION_CODE_DIRECTION
    return !applicable || !!value
  }),
})

export const schemaDealPaymentResolveMode = schemaDealPayment.shape({
  paymentDate: yup.string().required(REQUIRED_FIELD),
})
